/**
 * Normalize an item field to an array of ids.
 * Accepts arrays of numbers, arrays of { id } objects, or null/undefined.
 *
 * @param {any} value
 * @returns {number[]}
 */
function toIds(value) {
  if (!Array.isArray(value)) return [];
  return value.map((v) => (v && typeof v === 'object' ? v.id : v));
}

/**
 * Count +1 for every id in every filter that is also present on the item.
 * A post matching 3 out of 5 selected supertags contributes +3.
 *
 * @param {any} item
 * @param {{ field: string, ids: (number|string)[] }[]} filters
 */
function scoreItem(item, filters) {
  let score = 0;
  for (const filter of filters) {
    const itemIds = toIds(item[filter.field]);
    for (const id of filter.ids) {
      if (itemIds.includes(id)) score++;
    }
  }
  return score;
}

/**
 * Sort items by the number of filter-ids they match (descending).
 * Stable: items with equal score keep their input order.
 * Items with score 0 are excluded unless includeNoMatch is true.
 *
 * @template T
 * @param {T[]} items
 * @param {{ field: string, ids: (number|string)[] }[]} filters
 * @param {{ includeNoMatch?: boolean }} [options]
 * @returns {T[]}
 */
export default function filterAndSort(items, filters, { includeNoMatch = false } = {}) {
  if (!Array.isArray(items) || items.length === 0) return [];
  if (!Array.isArray(filters) || filters.length === 0) {
    return includeNoMatch ? [...items] : [];
  }

  const scored = items.map((item, index) => ({
    item,
    index,
    score: scoreItem(item, filters)
  }));

  const retained = includeNoMatch ? scored : scored.filter((s) => s.score > 0);
  retained.sort((a, b) => b.score - a.score || a.index - b.index);

  return retained.map((s) => s.item);
}
